import React from 'react';

const PageWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <div className="pt-20 lg:pt-0 xl:pt-10">{children}</div>;
};

export default PageWrapper;
